import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const IconSearch: React.FC<SvgIconProps> = ({sx}) => (
  <SvgIcon
    viewBox="0 0 18 18"
    sx={{
      color: COLORS.CERULEAN,
      width: 18, 
      height: 18,
      ...sx,
    }}
  >
    <path 
        d="M17.6151 16.1816L12.277 10.8435C13.1137 9.71119 13.6157 8.3167 13.6157 6.80508C13.6157 3.05113 10.559 0 6.81066 0C3.06229 0 0 3.05113 0 6.80508C0 10.559 3.05671 13.6102 6.81066 13.6102C8.28324 13.6102 9.64425 13.136 10.7598 12.3384L16.1091 17.6876C16.3155 17.894 16.5888 18 16.8621 18C17.1354 18 17.4087 17.894 17.6151 17.6876C18.0279 17.2749 18.0279 16.5999 17.6151 16.1816ZM2.05826 6.80508C2.05826 4.18345 4.18903 2.05268 6.81066 2.05268C9.43229 2.05268 11.5631 4.18345 11.5631 6.80508C11.5631 9.42671 9.43229 11.5575 6.81066 11.5575C4.18903 11.5575 2.05826 9.42671 2.05826 6.80508Z" 
        stroke="none"
        fill="currentColor"
    />
  </SvgIcon>
)
